module.exports = __webpack_public_path__ + "img/h5_banner02.1a937bfd.webp";